// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2j9d5","title":"Info_title__23X4R","selects":"Info_selects__2vwzc","requiredAsterisk":"Info_requiredAsterisk__IYq8y"};